import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvecontracts',
  templateUrl: './approvecontracts.component.html',
  styleUrls: ['./approvecontracts.component.css']
})
export class ApproveContractsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
